export default __webpack_public_path__ + "static/media/defendant-defendant.51c73c02.jpg";